export enum ModuleTypes {
    ENGINE = 'ENGINE',
    BRAKES = 'BRAKES',
    TRANSMISSION = 'TRANSMISSION',
    TURBO = 'TURBO',
    TYRES = 'TYRES'
}

export interface VehicleModule {
    id: number
    moduleKey: string
    icon: string
    moduleName: ModuleTypes
    level: number
    name: string
    bought: boolean
    equipped: boolean
    researched: boolean
    price: number
    otherInfo: VehicleModuleOtherInfo
}

export interface VehicleModuleOtherInfo {
    buyPrice: number,
    researchPrice: number,
    technicalCharacteristics: AnyModuleCharacteristics | EngineTechnicalCharacteristics
    effects: ModuleEffect[]
}

export interface ModuleEffect {
    param: string,
    value: number,
    change: number,
    positive: number
}

export interface ModuleView {
    name: string,
    moduleKey: string,
    level: number,
    type: ModuleTypes,
    price: number,
    xpPrice: number,
    icon: string,
    isResearched: boolean,
    isBought: boolean,
    isEquipped: boolean,
    technicalCharacteristics: AnyModuleCharacteristics,
    effects: ModuleEffect[]
}

export interface AnyModuleCharacteristics {
    resource: number
}

export interface EngineTechnicalCharacteristics extends AnyModuleCharacteristics {
    type: EngineTypes
    cylinders: string
    volume: string
    cylinderDiameter: string
    pistonTravel: string
    compression: string
    blockMaterial: Materials
    capMaterial: Materials
    timingDrive: EngineTimings
    oilType: OilTypes
    oilVolume: string
    fuelType: FuelType
    ecoClass: string
}

export type EngineTypes = "INLINE" | 'V_SHAPE' | 'W_SHAPE' | 'FLAT' | 'ROTARY'
export type EngineTimings = "CHAIN" | "BELT" | "GEAR"
export type Materials = "CAST_IRON" | "ALUMINIUM" | "STEEL"
export type OilTypes = "OIL_5W_40" | "OIL_5W_30"
export type FuelType = "RON_92" | "RON_95" | "RON_98" | "RON_100" | "DIESEL"